import { render, staticRenderFns } from "./learn5.vue?vue&type=template&id=6a02589b&scoped=true"
import script from "./learn5.vue?vue&type=script&lang=js"
export * from "./learn5.vue?vue&type=script&lang=js"
import style0 from "./learn5.vue?vue&type=style&index=0&id=6a02589b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a02589b",
  null
  
)

export default component.exports